import { MessageCircle, FileText, FileSpreadsheet, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

// Botão WhatsApp com escolha do formato: PDF (anexado) ou Excel (baixado para anexar).
export function WhatsAppMenu({ onPdf, onExcel, testId, className = "", disabled }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button disabled={disabled} className={`bg-emerald-600 text-white hover:bg-emerald-700 ${className}`} data-testid={testId}>
          <MessageCircle className="h-4 w-4" /> WhatsApp <ChevronDown className="h-3.5 w-3.5 opacity-80" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="border-slate-700 bg-slate-900 text-slate-100">
        <DropdownMenuItem onSelect={onPdf} className="cursor-pointer gap-2" data-testid={`${testId}-pdf`}>
          <FileText className="h-4 w-4 text-rose-300" /> Enviar PDF
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={onExcel} className="cursor-pointer gap-2" data-testid={`${testId}-excel`}>
          <FileSpreadsheet className="h-4 w-4 text-emerald-300" /> Enviar Excel (CSV)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
